import axios from 'axios'
import jsonp from 'jsonp'
import qs from 'qs'
import Vue from 'vue'

const CancelToken = axios.CancelToken

/**
 * 消息过滤
 */
const msgFiltering = (datas) => {
  let errors = datas.errors
  let messages = []
  // errors有返回对应信息
  if (typeof errors === 'object' && !Array.isArray(errors) && errors !== null) {
    for (let name in errors) {
      messages.push(errors[name])
      // for (let i = 0, l = errors[name].length; i < l; i++) {
      //   messages.push(errors[name][i])
      // }
    }
    return messages
  } else {
    return datas.message
  }
}
/**
 * 提示
 */
const tips = (message, type) => {
  Vue.prototype.$tips({
    message,
    type
  })
}

const myAxios = axios.create({
  withCredentials: true
})

axios.defaults.withCredentials = true

/**
 * 异步请求方法封装
 *
 * @param {String} type 请求类型, 包含get post put jsonp等
 * @param {Object} params 要提交的数据
 * @param {Boolean} useJson 将要提交的数据转为字符串拼接
 * @param {String} url 请求链接
 * @param {Function} success 请求成功执行的方法
 * @param {Function} fail 请求失败执行的方法，一般是status_code !== 200 情况下
 * @param {Function} error 请求错误执行的方法
 * @param {Function} callback 请求发送成功后执行方法（不管成功失败）
 * @param {Boolean} showError 是否显示错误提示，当status_code !== 200时会自动提示相关message，设置为false则不提示
 * @param {jsonpCallback} 设置jsonpCallback
 */

export const fetch = ({ type, params, data, url, useJson, success, fail, error, callback, showError, jsonpCallback, headers }) => {
  params = params || ''
  showError = typeof showError === 'undefined' ? true : showError
  if (type === 'jsonp') {
    let datas = []
    if (params && typeof params === 'object') {
      for (let key in params) {
        datas.push(key + '=' + params[key])
      }
      datas = datas.join('&')
    }
    let s = '?'
    if (url.indexOf(s) !== -1) {
      s = '&'
    }
    jsonp(url + s + datas, {
      // param: params,
      param: jsonpCallback || 'callback'
    }, (err, response) => {
      callback && callback(response)
      if (err) {
        error && error()
        if (showError) {
          tips('请求错误', 'error')
        }
        return false
      }
      if (response.status_code !== 200) {
        fail && fail(response)
        if (showError) {
          tips(response.message || '请求错误', 'error')
        }
        return false
      }
      success && success(response)
    })
  } else {
    // if (type === 'get') {
    //   params = {
    //     params
    //   }
    // } else {
    //   params = qs.stringify(params)
    // }
    // myAxios[type](url, params)
    if (!useJson) {
      params = qs.stringify(params)
    }
    const source = CancelToken.source()
    let promise
    if (type === 'get') {
      promise = myAxios({
        method: type,
        url,
        params,
        cancelToken: source.token,
        headers
      })
    } else {
      promise = myAxios({
        method: type,
        url,
        data,
        cancelToken: source.token,
        headers
      })
    }

    promise.then((response) => {
      response = response.data
      callback && callback(response)
      if ((response.status_code && response.status_code !== 200) || response.status && response.status !== 200) {
        let msg = msgFiltering(response)
        msg = Array.isArray(msg) ? msg.join('，') : msg
        if (fail) {
          fail(response, msg)
        }
        if (showError) {
          tips(msg || '请求错误', 'error')
        }
        return false
      }
      success && success(response)
    }).catch((e) => {
      let message = e && e.message ? e.message : '请求错误'
      console.log(message)
      error && error()
    })
    promise.$cancel = source.cancel
    return promise
  }
}



// WEBPACK FOOTER //
// ./src/commons/fetch.js